import {useReducer} from 'react';
import PerformanceEvaluationContext, {initialState} from "./PerformanceEvaluationContext";
import PerformanceEvaluationReducer from './PerformanceEvaluationReducer';

const PerformanceEvaluationState = (props:any) => {
    const [state,dispatch] = useReducer(PerformanceEvaluationReducer, initialState)
    return (
        <PerformanceEvaluationContext.Provider value={{state,dispatch}}>
                  {props.children}
        </PerformanceEvaluationContext.Provider>
    )
}

export default PerformanceEvaluationState;